export const getScoreColor = (score: number): string => {
    if (score >= 0.8) return 'success.main';
    if (score >= 0.6) return 'warning.main';
    return 'error.main';
};

export const getTierColor = (tier: number): string => {
    switch (tier) {
        case 1:
            return '#4caf50'; // Green
        case 2:
            return '#8bc34a'; // Light green
        case 3:
            return '#ffc107'; // Amber
        case 4:
            return '#ff9800'; // Orange
        case 5:
            return '#f44336'; // Red
        default:
            return '#9e9e9e'; // Grey
    }
};
